/* eslint-disable import/no-anonymous-default-export */
import environment from '../environments/Environment';
import HttpService from './HttpService';

export default {
    getMyTaskList(params) {
        return HttpService.get(environment.API_MY_TASK, {
            params,
        });
    },
    getMyTaskTodoList(params) {
        return HttpService.get(environment.API_MY_TASK + '/to-do-list', {
            params,
        });
    },
    getMyTaskFollowUp(params) {
        return HttpService.get(environment.API_MY_TASK + '/follow-up', {
            params,
        });
    },
    getMyTaskOperationDone(params) {
        return HttpService.get(environment.API_MY_TASK + '/operation-done', {
            params,
        });
    },
    getMyTaskRequestDone(params) {
        return HttpService.get(environment.API_MY_TASK + '/request-done', {
            params,
        });
    },
    getDSInformation(id) {
        return HttpService.get(
            environment.API_DS_REQUEST_FORM + `/information/${id}`
        );
    },
    editDSInformation(payload) {
        return HttpService.put(
            environment.API_DS_REQUEST_FORM + `/information`,
            payload
        );
    },
    accectMyTask(payload) {
        return HttpService.post(environment.API_MY_TASK + `/accept`, payload);
    },
    confirmMyTask(payload) {
        return HttpService.post(environment.API_MY_TASK + `/confirm`, payload);
    },
    getDataUsageDepartments(dsrTaskId) {
        return HttpService.get(
            environment.API_SEARCH_MY_TASK +
                `/data-usage-departments?dsrTaskId=${dsrTaskId}`
        );
    },
    getDataCollectDepartments(dsrTaskId) {
        return HttpService.get(
            environment.API_SEARCH_MY_TASK +
                `/data-collect-departments?dsrTaskId=${dsrTaskId}`
        );
    },
    getMyTaskDetail(dsrTaskId) {
        return HttpService.get(
            environment.API_SEARCH_MY_TASK + `/${dsrTaskId}`
        );
    },
    getActivityList(params) {
        return HttpService.get(
            environment.API_SEARCH_MY_TASK + '/search-activity',
            {
                params,
            }
        );
    },
    //Service Part 2
    getDepartmentEmail(departmentList) {
        return HttpService.post(
            environment.API_WFSECURE + `/department/email`,
            departmentList
        );
    },
    //reject
    rejectMyTask(payload) {
        return HttpService.post(
            environment.API_KYC_MY_TASK + '/reject',
            payload
        );
    },
    //continue,discontinue
    continueMyTask(payload) {
        return HttpService.patch(
            environment.API_KYC_MY_TASK + '/continue',
            payload
        );
    },
    //cancel
    getOperationCancel(dsrTaskId) {
        return HttpService.get(
            environment.API_MY_TASK + `/cancel/check/${dsrTaskId}`
        );
    },
    cancelMyTask(payload) {
        return HttpService.patch(
            environment.API_MY_TASK + '/confirm/canceling',
            payload
        );
    },
    //extend
    extendMyTask(payload) {
        return HttpService.post(
            environment.API_SEARCH_MY_TASK + '/extend',
            payload
        );
    },

    //Flow Complete
    getOperation(dsrTaskId) {
        return HttpService.get(
            environment.API_MY_TASK + `/complete/check/${dsrTaskId}`
        );
    },
    completeLast(payload) {
        return HttpService.post(
            environment.API_SEARCH_MY_TASK + '/complete/dpo',
            payload
        );
    },
    completeNotLast(payload) {
        return HttpService.post(
            environment.API_MY_TASK + '/complete/assignor',
            payload
        );
    },
    //preview operation
    getPreviewOperation(params) {
        return HttpService.get(environment.API_MY_TASK + '/preview', {
            params,
        });
    },
    confirmAcknowledge(payload) {
        return HttpService.patch(
            environment.API_MY_TASK + '/confirm/acknowledge',
            payload
        );
    },
    confirmReassign(payload) {
        return HttpService.patch(
            environment.API_MY_TASK + '/confirm/reassign',
            payload
        );
    },
    confirmRemind(payload) {
        return HttpService.patch(
            environment.API_MY_TASK + '/confirm/remind',
            payload
        );
    },

    // check workflow status
    checkStatusWorkflow(workFlowId) {
        return HttpService.get(
            environment.API_MY_TASK + `/work-flow/status/${workFlowId}`
        );
    },

    //History
    getHistories(params) {
        return HttpService.get(environment.API_MY_TASK + `/history`, {
            params,
        });
    },

    getHistoryDetail(params) {
        return HttpService.get(environment.API_MY_TASK + `/history/detail`, {
            params,
        });
    },
};
